import isDevEnv from 'utils/isDevEnv';
import { EventCollectorPayload } from './payloads';

async function fetchEventCollector(event: EventCollectorPayload) {
  // TODO: Don't test on Cypress
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (window && (window as any).Cypress) {
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(event),
  };

  try {
    await fetch(import.meta.env.VITE_EVENT_COLLECTOR_URL, options);
  } catch (e) {
    if (isDevEnv()) {
      // eslint-disable-next-line no-console
      console.error('Event collector request failed');
    }
  }
}

export default fetchEventCollector;
